import React from "react";
import { 
  Box,
  Avatar,
  Stack,
  Typography,
  IconButton
} from "@mui/material";
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import ReplyOutlinedIcon from '@mui/icons-material/ReplyOutlined';
import ThumbUpOutlinedIcon from '@mui/icons-material/ThumbUpOutlined';
import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';
import BookmarkBorderOutlinedIcon from '@mui/icons-material/BookmarkBorderOutlined';
import { useDispatch } from "react-redux";
import { postBookmark, postLike } from "Slices/thunks";

const Post = ({ data = {}, isReply = false, post, setOpenReply, setOpenShare }) => {
  const dispatch = useDispatch();

  const options = {
    day: "2-digit",
    month: "long",
    year: "numeric"
  }

  const handleLike = () => {
    dispatch(postLike({PostID: post.ID}))
  }

  const handleBookmark = () => {
    dispatch(postBookmark({PostID: post.ID}))
  }

  return (
    <Box sx={(theme) => ({ bgcolor: isReply ? `${theme.palette.white.main} !important` : theme.palette.background.default, display: 'flex', borderRadius: "8px", gap: 2, mt: isReply ? 2 : 0, p: isReply ? 2 : 0 })}>
      {/* <Avatar sx={{ bgcolor: data.user.avatarColor, width: 40, height: 40 }}>{data.user.initial}</Avatar> */}
      <Avatar sx={{ width: 40, height: 40 }} src={data.User?.ProfilePictureUrl}>{data.User?.FullName}</Avatar>
      <Box sx={{ flexGrow: 1 }}>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Box>
            <Typography variant="body1" sx={{ fontWeight: 'bold' }}>{data.User?.FullName}</Typography>
            <Typography variant="caption" color="text.secondary">
              {`${data.User?.UserType}`}
            </Typography>
          </Box>
          <Typography variant="caption" color="text.secondary">{new Date(data.CreatedAt).toLocaleDateString("default", options)}</Typography>
        </Stack>
        <Typography variant="body1" sx={{ my: 2 }} dangerouslySetInnerHTML={{__html: data.Content}}></Typography>
        <Stack direction="row" spacing={isReply ? 1 : 3} alignItems="center" sx={{ color: 'text.secondary' }}>
          {isReply ? (
            <>
              {/* <IconButton size="small" sx={{ color: 'secondary.light' }}><ThumbUpOutlinedIcon fontSize="small" /></IconButton>
              <IconButton size="small" sx={{ color: 'secondary.light' }}><ShareOutlinedIcon fontSize="small" /></IconButton>
              <IconButton size="small" sx={{ color: 'secondary.light' }}><ReplyOutlinedIcon fontSize="small" /></IconButton> */}
            </>
          ) : (
            <>
              <Stack direction="row" alignItems="center" spacing={0.5}>
                <IconButton size="small" sx={{  color: data.Interactions?.Like ? 'primary.main' : 'secondary.light' }}>
                  <ThumbUpOutlinedIcon sx={{ fontSize: 20 }} onClick={handleLike} />
                </IconButton>
                <Typography variant="body2">{data.Interactions?.Likes}</Typography>
              </Stack>
              <Stack direction="row" alignItems="center" spacing={0.5}>
                <IconButton size="small" onClick={() => setOpenShare(true)}>
                  <ShareOutlinedIcon sx={{ fontSize: 20 }} />
                </IconButton>
                <Typography variant="body2">{data.Interactions?.Shares}</Typography>
              </Stack>
              {/* <Stack direction="row" alignItems="center" spacing={0.5}>
                <ChatBubbleOutlineOutlinedIcon sx={{ fontSize: 20 }} />
                <Typography variant="body2">{data.Interactions?.Comments}</Typography>
              </Stack> */}
              <Stack direction="row" alignItems="center" spacing={0.5}>
                <IconButton size="small" onClick={() => setOpenReply(true)}>
                  <ReplyOutlinedIcon sx={{ fontSize: 20 }} />
                </IconButton>
                <Typography variant="body2">{data.Interactions?.Replies}</Typography>
              </Stack>
              <Stack direction="row" alignItems="center" spacing={0.5}>
                <IconButton size="small" sx={{ color: data.Interactions?.Bookmark ? 'primary.main' : 'secondary.light' }}>
                  <BookmarkBorderOutlinedIcon sx={{ fontSize: 20 }} onClick={handleBookmark} />
                </IconButton>
              </Stack>
            </>
          )}
        </Stack>
      </Box>
    </Box>
  );
}

export default Post;